import React, { useEffect, useMemo, useState, useCallback } from 'react';
import DataTable from 'react-data-table-component';
import { Card, CardHeader, CardBody } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import licenseService from '../../../Services/licenseService';

const POListTable = ({ refreshKey }) => {
    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);
    const [loading, setLoading] = useState(false);

    const fetchRows = useCallback(() => {
        setLoading(true);
        licenseService.listPOs({ page, limit })
            .then(res => {
                setRows(res.data.rows || []);
                setTotalRows(res.data.totalRows || 0);
            })
            .catch(err => console.log(err))
            .finally(() => setLoading(false));
    }, [page, limit]);

    useEffect(() => { fetchRows(); }, [fetchRows, refreshKey]);

    const columns = useMemo(() => [
        { name: 'PO Number', selector: r => r.po_number, sortable: true },
        {
            name: 'Asset',
            selector: r => r.po_property_id
                ? `${r.po_property_id.property_name} (${r.po_property_id.property_mall_code})`
                : '—',
            wrap: true, grow: 2
        },
        { name: 'Quantity', selector: r => r.po_quantity, sortable: true },
        {
            name: 'Issue Date',
            selector: r => r.po_issue_date ? new Date(r.po_issue_date).toLocaleDateString() : '—',
            sortable: true
        },
        {
            name: 'Created By',
            selector: r => r.po_created_by
                ? (r.po_created_by.username || `${r.po_created_by.userFirstName || ''} ${r.po_created_by.userLastName || ''}`.trim())
                : '—'
        },
        {
            name: 'Created At',
            selector: r => r.createdAt ? new Date(r.createdAt).toLocaleString() : '—',
            sortable: true
        }
    ], []);

    return (
        <Card>
            <CardHeader>
                <H5 attrH5={{ className: 'mb-0' }}>Purchase Orders</H5>
                <div className='f-12 f-light mt-1'>All POs within your scope, newest first</div>
            </CardHeader>
            <CardBody>
                <DataTable
                    columns={columns}
                    data={rows}
                    progressPending={loading}
                    pagination paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={p => setPage(p)}
                    onChangeRowsPerPage={l => { setLimit(l); setPage(1); }}
                    paginationPerPage={limit}
                    highlightOnHover striped dense
                />
            </CardBody>
        </Card>
    );
};

export default POListTable;
